import type { HiddenReason } from '../../types/api'

/**
 * The details that hid nearby results, one chip each: "Mode - you chose Coaching Institute - 5".
 *
 * <p>A count alone says something is hidden; this says what to change. `who` is whose words the
 * value is in - a learner's own map says "you chose", a provider's says "they asked for" - and the
 * value is left out where several learners said different things.
 */
export function HiddenReasons({
  reasons,
  who,
}: {
  reasons: HiddenReason[] | undefined
  who: 'you chose' | 'they asked for'
}) {
  if (!reasons || reasons.length === 0) return null
  return (
    <span className="flex flex-wrap gap-1.5">
      {reasons.map((r) => (
        <span key={r.attribute} className="rounded-full border border-sky-300 bg-white/70 px-2 py-0.5 text-xs font-medium">
          {r.attribute}
          {r.value && <span className="text-sky-700"> - {who} {r.value}</span>}
          <span className="text-sky-600"> ({r.count})</span>
        </span>
      ))}
    </span>
  )
}
